<template>
  <div>
    <LoadingGif v-if="loading"></LoadingGif>
    <div v-if="!loading">
      <CCardHeader>
        {{ cases.length }}
        <span v-if="cases.length === 1">result</span>
        <span v-else>results</span>
        for "{{ decodeURI(term.replace(/_/gi, "/")) }}"
      </CCardHeader>
      <br />
      <horizontal-scroll>
        <data-table v-bind="bindings" />
      </horizontal-scroll>
    </div>
  </div>
</template>

<script>
import LoadingGif from "./LoadingGif.vue";

import DataTable from "@andresouzaabreu/vue-data-table";
// import "bootstrap/dist/css/bootstrap.min.css";
import "@andresouzaabreu/vue-data-table/dist/DataTable.css";

import ActionButton from "../components/ActionButton.vue";
import FolderBadge from "../components/FolderBadge.vue";

import HorizontalScroll from "vue-horizontal-scroll";
import "vue-horizontal-scroll/dist/vue-horizontal-scroll.css";

export default {
  name: "FilesSearch",
  components: {
    LoadingGif,
    HorizontalScroll,
    DataTable,
    ActionButton,
    FolderBadge,
  },
  data() {
    return {
      loading: false,
      cases: [],
      term: "",
    };
  },
  computed: {
    bindings() {
      return {
        columns: [
          {
            key: "file_reference",
            title: "Reference",
            sortable: true,
            sortingFunction: function(a, b) {
              return ("" + a.file_reference).localeCompare(b.file_reference);
            },
          },
          {
            title: "Folder",
            sortable: false,
            component: FolderBadge,
          },
          {
            title: "Actions",
            sortable: false,
            component: ActionButton,
          },
          {
            key: "pri_lawyer",
            title: "Pri User",
            sortable: true,
            sortingFunction: function(a, b) {
              return ("" + a.pri_lawyer).localeCompare(b.pri_lawyer);
            },
          },
          {
            key: "bring_up_date_pri",
            title: "Pri BU",
            // sortable: true,

            sortingFunction: function(a, b) {
              var da = new Date(a.bring_up_date_pri);
              var db = new Date(b.bring_up_date_pri);

              return da.getTime() - db.getTime();
            },
          },
          {
            key: "sec_lawyer",
            title: "Sec User",
            sortable: true,
            sortingFunction: function(a, b) {
              return ("" + a.sec_lawyer).localeCompare(b.sec_lawyer);
            },
          },
          {
            key: "bring_up_date_sec",
            title: "Sec BU",
            sortable: true,

            sortingFunction: function(a, b) {
              var da = new Date(a.bring_up_date_sec);
              var db = new Date(b.bring_up_date_sec);

              return da.getTime() - db.getTime();
            },
          },
          {
            key: "client_name",
            title: "Client",
            sortable: true,
            sortingFunction: function(a, b) {
              return ("" + a.client_name).localeCompare(b.client_name);
            },
          },
          {
            key: "category",
            title: "Category",
            sortable: true,
            sortingFunction: function(a, b) {
              return ("" + a.category).localeCompare(b.category);
            },
          },
          {
            key: "date_opened",
            title: "Date Opened",
            sortable: true,
            sortingFunction: function(a, b) {
              var da = new Date(a.date_opened);
              var db = new Date(b.date_opened);

              return da.getTime() - db.getTime();
            },
          },
          {
            key: "matter_summary",
            title: "Summary",
            sortable: false,
          },
        ],
        data: this.cases,
        showDownloadButton: false,
        sortingMode: "single",
        perPageSizes: [5, 10, 25, 50, 100],
        defaultPerPage: 5,
        /* other props...*/
      };
    },
  },

  mounted() {
    this.fetch_search_cases();
  },
  methods: {
    fetch_search_cases() {
      const axios = require("axios");

      this.loading = true;

      var this_ = this;

      const search_term = window.location.pathname.split("/")[3];
      this.term = search_term;

      axios
        .get("/cases/search/" + search_term)
        .then(function(res) {
          // handle success
          this_.cases = res.data;
          console.log(res);
          this_.loading = false;
        })
        .catch(function(error) {
          // handle error
          console.log(error);
          this_.loading = false;
        });
    },
  },
};
</script>
